// hooks/useUserId.js
import { useEffect, useState } from 'react';
import { auth } from '../firebase';

export const useUserId = () => {
    const [userId, setUserId] = useState(null);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (user) {
                setUserId(user.uid);
            } else {
                // fallback depuis localStorage si déjà logué précédemment
                const storedUser = localStorage.getItem('user');
                const localUser = storedUser ? JSON.parse(storedUser) : null;
                setUserId(localUser?.uid ?? null);

            }
        });

        return () => unsubscribe();
    }, []);
    /*const storedUser2 = localStorage.getItem('user');
    const localUser2 = storedUser2 ? JSON.parse(storedUser2) : null;
    const Uid = localStorage.getItem('user/Uid');
    console.log(Uid);*/
    return userId;
};
